import React, { useState } from 'react'
import s from './index.module.scss'
import Input from '../Input'
import { ReactComponent as BackArrow } from '../../../assets/icons/back-arrow.svg'
import dateFormat from 'dateformat'

interface IProps {
	setDateFrom: (value: string) => void
	setDateTo: (value: string) => void
}

const TableDateFilter = ({ setDateFrom, setDateTo }: IProps) => {
	const [from, setFrom] = useState('')
	const [to, setTo] = useState('')

	const changeFrom = (ev: React.ChangeEvent<HTMLInputElement>) => {
		setFrom(ev.target.value)
		setDateFrom(ev.target.value)
	}

	const changeTo = (ev: React.ChangeEvent<HTMLInputElement>) => {
		setTo(ev.target.value)
		setDateTo(ev.target.value)
	}

	const resetHandler = () => {
		setFrom('')
		setDateFrom('')
		setTo('')
		setDateTo('')
	}

	return (
		<div>
			<p className={s.text}>Оберіть період</p>
			<div className={s.wrapper}>
				<Input type={'date'} className={s.input} value={from} onChange={changeFrom} />
				<span className={s.delimiter} />
				<Input type={'date'} className={s.input} value={to} onChange={changeTo} />

				<button className={s.btn} onClick={resetHandler}>
					<BackArrow /> За весь час
				</button>
			</div>
		</div>
	)
}

export default TableDateFilter
